<template>
  <div class="ui-container">
    <h2>Tags</h2>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Tag :text="`.tag.${color}`" :class="color" />
      </template>
    </div>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Tag :text="`.tag.icon.${color}`" :color="color" icon="bi bi-fan" />
      </template>
    </div>
    <div class="ui-block inline">
      <template v-for="color in colors.slice(0, 4)" :key="color">
        <Tag :text="`.tag.outline.${color}`" :class="color" :outline="true" />
      </template>
    </div>
  </div>
</template>

<script setup>
const colors = [
  "black",
  "yellow",
  "red",
  "green",
  "grey-light",
  "yellow-light",
  "red-light",
  "green-light",
];
</script>
